import styles from './index.module.scss'

import SearchHouseField from '../../molecules/SearchHouseField'
// import Form from 'react-bootstrap/Form'
// import { useState } from 'react';

const Toolbar = ({Opts, trackingSysId, setHouse, onDataReceived, setErrorData, setWarnData, setFormData}) => {
  // const [trackingMethods, ] = useState(Opts);
  return (
    <>
      <div className={styles.Toolbar}>
        {/* <Form.Select className={styles.ToolbarDropdown}>
        {trackingMethods.map((option) => (
          option.active ? <option key={option.id} value={option.id}>{option.description}</option> : null
        ))}
        </Form.Select> */}
      <SearchHouseField trackingSysId={trackingSysId} setHouse={setHouse} onDataReceived={onDataReceived} setErrorData={setErrorData} setWarnData={setWarnData} setFormData={setFormData}/>
      </div>
    </>
  )
}

export default Toolbar